<h3>Import Json</h3>
<p><i>*Paste json here and click upload</i></p>

<div class="row">
  <div class="col-md-12">
    <mat-form-field>
      <textarea cols="50" mdInput placeholder="JSON" [(ngModel)]="jsonToUpload"></textarea>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <button class="btn btn-primary pull-right" (click)="upload()">Upload</button>
  </div>
</div>
